import React from "react";
import { Typography } from "@material-tailwind/react";

export default function PasswordRecoveryForm({ formData, handleChange, handleSubmit, changeForm }) {
    return (
        <div className="w-full lg:w-3/5 mt-24">
            <div className="text-center">
                <Typography variant="h2" className="font-bold mb-4">RECUPERA TU CONTRASEÑA</Typography>
                <Typography variant="paragraph" color="blue-gray" className="text-lg font-normal">
                    Ingresa tu correo electrónico para recuperar tu contraseña.
                </Typography>
            </div>
            <form className="mt-8 mb-2 mx-auto w-80 max-w-screen-lg lg:w-1/2">
                <div className="mb-1 flex flex-col gap-6">
                    <label htmlFor="email" className="-mb-3 font-medium text-blue-gray-700">Correo Electrónico</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        className="border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-gray-900"
                        placeholder="example@mail.com"
                        required
                    />
                </div>
                <button
                    type="submit"
                    className="mt-6 bg-black text-white py-2 px-4 rounded hover:shadow-lg font-sans uppercase w-full font-bold text-xs"
                >
                    Recuperar Contraseña
                </button>
                <div className="flex items-center justify-center gap-2 mt-6">
                    <Typography variant="small" className="font-medium text-gray-900">
                        <button onClick={changeForm} className="text-blue-500 underline">
                            Regresar al inicio de sesión
                        </button>
                    </Typography>
                </div>
            </form>
        </div>
    );
}
